// extracted by mini-css-extract-plugin
export default {"mainContainer":"TermsAndConditionCareCredit_mainContainer__h5XOa"};